import { useMutation, useQueryClient } from '@tanstack/react-query';
import { formBuilderApi, formBuilderKeys } from '@/features/quote-and-apply-builder';
import type { SaveFormParams, SaveFormResult } from '@/features/quote-and-apply-builder';

export function useSaveForm() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: SaveFormParams) => formBuilderApi.saveForm(params),
    onSuccess: (data: SaveFormResult, params: SaveFormParams) => {
      if (!data.success) return;

      const formId = data.formId;

      // Prefer the server-verified config (read-after-write) over client-constructed data
      const updatedConfig: PolicyFormConfig = data.savedFormConfig ?? {
        formDefinition: params.formDefinition,
        formMetadata: params.formMetadata,
        name: params.name,
        fundingPolicyTypeId: params.fundingPolicyTypeId,
        ...(params.stateCode && { stateCode: params.stateCode }),
      };
      queryClient.setQueryData(formBuilderKeys.detail(formId), updatedConfig);
      queryClient.invalidateQueries({ queryKey: formBuilderKeys.lists() });
    },
  });
}
